import PatientManagementHeader from './PatientManagementHeader.view';

export default PatientManagementHeader;
